import { Icon } from "@chakra-ui/react";
const WindowsIcon = () => {
  return (
    <>
      <Icon
        width="4"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.975 12.5209C10.9811 14.9196 10.9883 18.995 10.9943 22.1625C15.3311 22.749 19.668 23.3536 23.9976 24C23.9976 20.2185 24.0024 16.4535 23.9976 12.8555C19.6571 12.8555 15.3179 12.5209 10.975 12.5209ZM0 12.5221V20.666C3.27098 21.1074 6.54195 21.5292 9.80692 22.0113C9.81293 18.8607 9.80451 15.7091 9.80451 12.5584C6.53594 12.5644 3.26857 12.5113 0 12.5221ZM0 3.41191V11.533C3.27098 11.5414 6.54195 11.4919 9.81293 11.4955C9.81053 8.35204 9.81053 5.21242 9.80692 2.06895C6.53353 2.47792 3.26015 2.91059 0 3.41191ZM24 11.366C19.6656 11.3828 15.3311 11.4489 10.9943 11.4621C10.9919 8.26706 10.9919 5.07584 10.9943 1.8832C15.3227 1.22236 19.6608 0.600864 23.9976 0C24 3.78991 23.9976 7.5761 24 11.366Z"
          fill="white"
        />
      </Icon>
    </>
  );
};
export default WindowsIcon;
